// setClickedShareButton.js
'use strict';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';

/**
 * Set clicked share button
 * @kind action
 * @param {string} {messageId} - story message id.
 * @param {boolean} {clicked} - is clicked share button.
 * @return {Promise} Action promise.
 */
const setClickedShareButton =
  ({ messageId, clicked }) =>
  async dispatch => {
    return dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        data: {
          isClikedShareButton: clicked,
        },
        selectPath: ['message', messageId],
      },
    });
  };

export default setClickedShareButton;
